import { render, staticRenderFns } from "./ClassCate.vue?vue&type=template&id=c3bc79a8&scoped=true&"
import script from "./ClassCate.vue?vue&type=script&lang=js&"
export * from "./ClassCate.vue?vue&type=script&lang=js&"
import style0 from "./ClassCate.vue?vue&type=style&index=0&id=c3bc79a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bc79a8",
  null
  
)

export default component.exports